import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router";
import PathInfo from "../../model/PathInfo";
import { useApiClient } from "../../contexts/ApiClientContext";
import AnnexData from "../../model/AnnexData";
import APIEndPoints from "../../utils/APIEndPoints";
import PathDisplay from "../common/PathDisplay";

/*
  Component to manage the entire DOCUMENTS section
*/
function AnnexDataSection() {
  // read the ID from the url
  const { id } = useParams();
  // store data path
  const [pathInfo, setPathInfo] = useState<PathInfo | undefined>(undefined);
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // reference to Location, to update path when it changes
  const location = useLocation();

  useEffect(() => {
    const getPathInfo = async () => {
      if (id) {
        const info = await apiClient?.get<AnnexData>({
          url: APIEndPoints.ANNEXDATA.ONE(parseInt(id)),
        });

        setPathInfo(info.parent);
      }
    };
    getPathInfo();
  }, [location]);

  return (
    <div>
      <PathDisplay data={pathInfo!} />
      <Outlet />
    </div>
  );
}

export default AnnexDataSection;
